export default __webpack_public_path__ + "static/media/youtube.15393794.svg";